import { render, staticRenderFns } from "./fileName.vue?vue&type=template&id=273b037e&scoped=true&"
import script from "./fileName.vue?vue&type=script&lang=js&"
export * from "./fileName.vue?vue&type=script&lang=js&"
import style0 from "./fileName.vue?vue&type=style&index=0&id=273b037e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273b037e",
  null
  
)

export default component.exports